import React, {  useState } from 'react'
import '../css/styles.css'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import Select from 'react-select';
import Swal from 'sweetalert2'


const ContactForm = (props) => {
  const [formData, setFormData] = useState({});
  let stateButtons = 0;
  if(localStorage.getItem("user") !== null){
    stateButtons = 1;
  }

  const updateInput = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    })
  }
  const updateInputSelect = e => {
    console.log(e);
    setFormData({
      ...formData,
      ["panfleto"]: e.value,
      ["programa"]: e.label,
    })
  }

  const updateInputPhone = e => {
    setFormData({
      ...formData,
      "phone": document.querySelector("input[type=tel]").value,
    })
  }
  const handleSubmit = event => {
    event.preventDefault()
    sendEmail()
    setFormData({
      name: '',
      email: '',
      phone: '',
      interes: '',
      message: '',
      panfleto : '',
      programa : ''
    })
  }

  const gotoAsesor = () => {
    var win = window.open(`https://wa.me/+52${process.env.REACT_APP_NUMBER_LEAD}?text=${process.env.REACT_APP_HELLO}`, '_blank');
    win.focus();
  }

  const retry = () => {
    localStorage.removeItem("user");
    window.location.reload(false);
  }
  let panfleto = [
    {label:"Informática",  value : 19},
    {label:"Administración",value : 15},
    {label:"Contaduría", value : 18},
    {label:"Mercadotecnia",value : 17},
    {label:"Derecho",value : 20},
    {label:"Educación",value : 14},
    {label:"Turismo", value: 16},
    {label:"Proyectos",value : 24},
  ];

  const sendEmail = () => {
    let myData = {
      "key" : "d9470e51841b4db13a7b4f3428837748",
      "token" : "147-1254073400-021931df180530bc7618d79c7a5ebbf3",
      "nombre": formData.name,
      "apat" : "Formulario",
      "amat" : "Formulario",
      "email": formData.email,
      "celular": formData.phone,
      "antecedentes": "Contactado para enviarle la oferta Interesado:"+formData.programa+"; El interesado dijo: "+formData.message,
      "procedencia_id": 9,
      "brochure_id" : formData.panfleto,
      "user_id" : 932
    }
    Swal.fire({
      title: 'Un segundo ...',
      text : "Estamos enviando la información",
      allowEscapeKey: false,
      allowOutsideClick: false,
      onOpen: () => {
        Swal.showLoading();
      },
      showConfirmButton : false
    });
    fetch("https://ecm.e-dav.net/api/client/web-register",{
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(
          myData
        )
      })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        if(data.error){
          Swal.fire({
            "title" : "Atención",
            "icon" : "error",
            "text" : data.error
          })
        } else {
          localStorage.setItem("user",JSON.stringify({"interes":props.interes,"desc":props.desc}));
          Swal.fire({
            "title" : "¡Perfecto!",
            "icon" : "info",
            "text" : "Información enviada, en breve serás contactado por un asesor educativo.",
            "confirmButtonText" : "Entendido"
          }).then(() => {
            window.location.reload(false);
          });
        }
      });

  }

  return (
    <>
      <form  className={stateButtons == 1 ? "d-none" : ""} onSubmit={handleSubmit} id="formulario">
        <input
          className='form-control'
          type="text"
          name="name"
          placeholder="Mi nombre completo"
          onChange={updateInput}
          value={formData.name || ''}
          required
        />

        <Select
          name="panfleto"
          onChange={updateInputSelect}
          options={panfleto}
          className="mb-4"
        />

        <input
          type="email"
          name="email"
          className='form-control'
          placeholder="david@e-dav.net"
          onChange={updateInput}
          value={formData.email || ''}
          required
        />

        <PhoneInput
          country={'mx'}
          value={formData.phone || ''}
          onChange={updateInputPhone}
          inputProps={{
            name: 'phone',
            id:"phone",
            placeholder: "+52 551 452 8499",
            required: true,
          }}
          isValid={(value, country) => {
            let real = value.substring((country.dialCode.length));
            if (real.length !== 10) {
              return 'Número no válido: '+real;
            } else if (value.match(/1234567890/)) {
              return false;
            } else {
              return true;
            }
          }}
        />
        
        <textarea
          type="text"
          className='form-control mt-4'
          name="message"
          placeholder="¿Quieres expresar algo adicional?"
          onChange={updateInput}
          value={formData.message || ''}
        ></textarea>

        <button type="submit">ENVIAR PANFLETO</button>
      </form>
      <div className={stateButtons == 0 ? "d-none" : ""}>
        <button onClick={gotoAsesor} class="enviar mt-2 beforesend" id="asesor">Asesor académico</button>
        <div class="text-center mt-4 beforesend">
          <a href="/" role="button" id="retry" onClick={retry}>Volver a intentar</a>
        </div>
      </div>
    </>
  )
}


export default ContactForm